import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import NavBar from '../NavBar';
import Footer from '../Footer';
import HearingTestExitIntent from '../HearingTestExitIntent';
import CountryPopup from '../CountryPopup';
import { shortCodes } from '../../utils/variables';

import '../../css/style.scss';

const Layout = ({ children, fontSerif }) => {
	return (
		<MDXProvider components={shortCodes}>
			<NavBar />
			<div className={`${fontSerif ? 'u-font-serif' : ''}`}>{children}</div>
			<Footer />
			<HearingTestExitIntent />
			<CountryPopup />
		</MDXProvider>
	);
};

export default Layout;
